/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';
import classNames from 'classnames';
import { AttrNumber } from '../../types/attributes';
import { PushDataLayerFn } from '../../types/pushDataLayer';
import {
  formatAttributeItemValue,
  formatNumberWithSeparator,
} from '../../utils/helpers';
import Button from '../Button';
import AwardIcon from '../icons/AwardIcon';
import Tooltip from '../Tooltip';
import { WrapperInfoBlock } from './ProductContent';

type ProductVerticalTableProps = {
  data: AttrNumber[];
  provider?: string;
  title: string;
  pushDataLayer: PushDataLayerFn;
};

const ProductVerticalTable: React.FC<ProductVerticalTableProps> = ({
  data,
  provider,
  title,
  pushDataLayer,
}) => {
  const value = data.map((attr) =>
    formatNumberWithSeparator({
      value: formatAttributeItemValue(attr, true),
      thousandsSeparator: ',',
    }),
  );

  return (
    <WrapperInfoBlock icon={<AwardIcon />} title={title}>
      {data.length
        ? data.map((row, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              className={classNames(
                'mb-2 flex flex-row justify-between border-b border-b-gray-300 md:items-center',
                {
                  'pb-2 md:mb-4 md:pb-4': index !== data.length - 1,
                  '!mb-0 border-b-0 pb-0': index === data.length - 1,
                },
              )}
            >
              <p className="mb-1 min-w-[30%] max-w-3/5 font-medium text-gray-700 text-sm leading-line-height/lg-relaxed md:mb-0 md:text-lg md:leading-line-height/xl">
                {row.label}
              </p>
              <div className="flex items-center justify-center font-semibold text-gray-900 text-sm leading-line-height/sm md:text-lg md:leading-line-height/xl">
                <span> {value[index]}</span>
                {row.additional_information && (
                  <Button
                    variant="text"
                    className="p-1"
                    onClick={() =>
                      pushDataLayer({
                        event: 'product_interaction',
                        location: 'product page',
                        component_type: 'tooltip',
                        component_title: `${title}_${row.label}`,
                        action: 'hover',
                        item_list_name: 'product-page',
                        items: [
                          {
                            item_id: row.name?.uid,
                            item_name: row.name?.uid,
                            item_brand: provider,
                          },
                        ],
                      })
                    }
                  >
                    <Tooltip
                      placement="left"
                      content={row.additional_information}
                    />
                  </Button>
                )}
              </div>
            </div>
          ))
        : null}
    </WrapperInfoBlock>
  );
};

export default ProductVerticalTable;
